'use strict'

var drain = require('./drain')

module.exports = function onEnd (done) {
  return drain(null, done)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/pull-stream/sinks/on-end.js
// module id = sfwq
// module chunks = 0